import { useRef, useEffect } from 'preact/hooks';

export function useFocusTrap() {
	const firstElementRef = useRef<HTMLSpanElement>(null);
	const lastElementRef = useRef<HTMLSpanElement>(null);
	const containerElementRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		const onFirstElementFocus = (event: FocusEvent) => {
			if (
				event.relatedTarget &&
				(!containerElementRef.current ||
					containerElementRef.current?.contains(event.relatedTarget as HTMLElement)) &&
				event.relatedTarget !== lastElementRef.current
			) {
				lastElementRef.current?.focus();
			}
		};

		const onLastElementFocus = (event: FocusEvent) => {
			if (event.relatedTarget !== firstElementRef.current) {
				event.preventDefault();
				firstElementRef.current?.focus();
			}
		};

		firstElementRef.current?.addEventListener('focus', onFirstElementFocus);
		lastElementRef.current?.addEventListener('focus', onLastElementFocus);

		return () => {
			firstElementRef.current?.removeEventListener('focus', onFirstElementFocus);
			lastElementRef.current?.removeEventListener('focus', onLastElementFocus);
		};
	}, [firstElementRef.current, lastElementRef.current]);

	return [firstElementRef, lastElementRef, containerElementRef] as const;
}
